import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import zh_TW from 'vee-validate/dist/locale/zh_TW'
import VeeValidate, { Validator } from 'vee-validate'
import i18n from '@/utils/i18n'
import { siteLogin, setupRefreshToken } from '@/utils/user'
import { loginByUid } from '@/api/user'
import { getShopInfo } from '@/api/shop'
import { showNotice, getStoreCode, loadCSSbystore, setDefaultLangcode, setAllowLangcode, defaultLangcode, validateLangPath, getLangPath, pathWithLangPath, getImgUrl, getLangcode } from '@/utils/tool'
import { gtmInit } from '@/utils/gtmtool'
import { initscriptbypartner } from '@/utils/initpartnerscript'
import '@/utils/filters'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.min.css'
import 'swiper/dist/css/swiper.css'
import '@/assets/custom.css'
import '@/assets/append.css'

// load the css file
loadCSSbystore()

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Validator.extend(`phone`, {
  // 驗證規則，符合規則通過，否則不通過 (規則為台灣電話號碼)
  validate: (value, ref) => {
    return /((?=(09))[0-9]{10})$/.test(value)
  }
})

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  i18nRootKey: 'validations', // customize the root path for validation messages.
  fieldsBagName: 'formFields',
  locale: 'zh_TW',
  dictionary: {
    zh_TW: zh_TW
  }
})

// 不能在iframe中
// if (window !== window.top) {
//   window.top.location.href = window.location.href
// }

store.commit('SET_NOTICE_MESSAGE', null)
store.commit('SET_CUS_NOTICE', null)
store.commit('SET_LOADING', true)
store.commit('SET_LOAD_COMPLETED', false)

const host = new URL(window.location.href || document.location.href)

// 處理不同通路商後台需要預先載入的script檔案
initscriptbypartner()
// 偵測網址channel
// const channel = process.env.VUE_APP_CHANNEL_CODE ? process.env.VUE_APP_CHANNEL_CODE : host.hostname.split('.')[0]
// store.commit('SET_CHANNEL', channel)

// 呈現ui
new Vue({
  router,
  store,
  i18n,
  created() {
    // 偵測happygo app進來的uid
    const uid = host.searchParams.get('uid')
    if (uid && getStoreCode() === 'happygo') {
      // 使用happyGo uid登入3T
      loginByUid(uid)
        .then(response => {
          siteLogin(response, window.location.pathname)
        })
        .catch(() => {})
        .finally(() => {
          store.commit('SET_LOADING', false)
          // store.commit('SET_LOAD_COMPLETED', true)
        })
    } else {
      setupRefreshToken()
      store.commit('SET_LOADING', false)
      // store.commit('SET_LOAD_COMPLETED', true)
    }

    // partner code 7天
    const partner_code = host.searchParams.get('partner')
    if (partner_code && this.$cookies.get('partner_code') !== partner_code) {
      this.$cookies.set('partner_code', partner_code, '10d')
    } else if (host.host.includes('oppaylater.3tet.com')) {
      // 例外處理: 台哥大 > partner_code = oppaylater
      this.$cookies.set('partner_code', 'oppaylater', '10d')
    }

    // 商家資訊
    getShopInfo({lang:getLangPath()})
      .then(response => {
        // 比對版本
        const clientVersion = parseFloat(process.env.VUE_APP_VERSION)
        const serverVersion = parseFloat(response.data.data.version)
        if (serverVersion > clientVersion) {
          showNotice(this.$langt('請重新載入頁面 更新程式版本'), function() {
            window.location.reload()
          })
        }

        setDefaultLangcode(response.data.data.lang_code)
        setAllowLangcode(response.data.data.langs)

        // 預設語系，不應該出現在 url 路徑上，直接轉址回預設語系路徑 //
        if (getLangPath().toLowerCase() === defaultLangcode().toLowerCase()) {
          window.location.href = '/'
        }

        // 合法語系檢查，不合法的語系直接導引到預設錯誤網頁 //
        if (!validateLangPath(getLangcode(), response.data.data.langs)) {
          showNotice(this.$langt('不支援此語系 將重新轉往預設語系'), function() {
            window.location.href = '/'
          })
        }
        // 比較現在語系 與 記錄中的語系，進行儲存或轉址 //
        if (getLangPath() !== '') {
          // 儲存選擇的語系 //
          this.$store.commit('SET_LANG_PATH', getLangPath())
        } else if (this.$store.getters.langPath !== '') {
          if (this.$store.getters.langPath === getLangcode()) {
            // 儲存的路徑為預設語系的langcode，應該為 ''，來自於系統異動語系造成 //
            this.$store.commit('SET_LANG_PATH', getLangPath())
          } else if (validateLangPath(this.$store.getters.langPath, response.data.data.langs)) {
            // 依照 langcode 切換路徑 //
            window.location.href = pathWithLangPath(window.location.href, this.$store.getters.langPath)
          }
        }

        // load the gtm from api
        if (response.data.data.ga_code) gtmInit(response.data.data.ga_code)

        this.$store.commit('SET_INFO', response.data.data)
        this.$store.commit('SET_CURRENCY_CODE', response.data.data.currency_code)
        this.$store.commit('SET_EXTRA_TAX_RATE', response.data.data.is_tax_extra ? (response.data.data.tax_rate * 0.01) : 0)
        this.$store.commit('SET_CURRENCY_DECIMAL_PLACE', response.data.data.currency_decimal_place ? response.data.data.currency_decimal_place : 0)
        this.loadLanguageData()
        // 換版型
        // if (
        //   response.data.data.theme_file !== undefined &&
        //   response.data.data.theme_file !== ''
        // ) {
        //   const file = document.createElement('link')
        //   file.rel = 'stylesheet'
        //   file.href = response.data.data.theme_file
        //   document.head.appendChild(file)
        // }

        const metaDesc = document.createElement('meta')
        metaDesc.name = 'description'
        metaDesc.content = this.$store.getters.shopInfo.description
        document.getElementsByTagName('head')[0].appendChild(metaDesc)

        const metaKeyword = document.createElement('meta')
        metaKeyword.name = 'keyword'
        metaKeyword.content = this.$store.getters.shopInfo.keyword
        document.getElementsByTagName('head')[0].appendChild(metaKeyword)
      })
      .catch(() => {})
  },
  methods: {
    async loadLanguageData() {
      const langcode = getLangcode()
      const domain = getImgUrl()
      const path = `${domain}/upload/lang/lang_web_${langcode}.js` + '?V=' + new Date().getMilliseconds()
      try {
        if (langcode !== 'tw') {
          const veeValidateDictionary = await import(
            /* webpackChunkName: "vee-validate-locale-[request]" */
            'vee-validate/dist/locale/' + (langcode === 'zh-Hans' ? 'zh_CN' : langcode)
          )
          Validator.localize(langcode, veeValidateDictionary)
          this.$validator.locale = langcode
        }
        this.$i18n.locale = langcode
        const text = await (await fetch(path)).text()
        // remove script header data = //
        const pos = text.indexOf('{')
        if (pos < 0) {
          throw new Error('lang data format error')
        }

        const jsonData = JSON.parse(text.substring(pos))
        this.$i18n.setLocaleMessage(langcode, jsonData)
      } catch (error) {
        // load lang file fail.
      }
      store.commit('SET_LOAD_COMPLETED', true)
    }
  },
  render: h => h(App)
}).$mount('#app')
